import { useEffect, useState, useMemo } from "react";
import {
  Typography,
  Paper,
  Grid,
  TextField,
  Collapse,
  IconButton,
  Button,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ApiServices } from "../../utils/ApiService";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from 'notistack';

export default function EmployeeGridPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowData, setRowData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const name = JSON.parse(localStorage.getItem("user"))?.name || "";

  const handleDelete = async (id) => {
    try 
    {
      const res = await ApiServices.patch(`employee/${id}`, { deleted_by: name})
      if(res?.status === 200)
        {
            enqueueSnackbar("Employee Deleted Success", { variant: 'success' });
            fetchData()
        }
      else{
            enqueueSnackbar("Failed to delete data", { variant: "error" });
      }  
    } catch (error) 
    {
      const err = error?.response?.data?.message || 'Failed to delete employee data.';
      enqueueSnackbar(err, { variant: 'error' });
    }
  }

   const fetchData = async () => {

    // if (rowData.length === 0) {
        setLoading(true);
      try {
        const res = await ApiServices.get("employee");
        if (res?.status === 200) {
          const apiData = res?.data?.employees;
          setRowData(apiData?.length ? apiData : []);
        } else {
          console.error("Error fetching employees:", res);
        }
      } catch (err) {
        console.error("catch error:", err);
        // setRowData([]);
      }
      finally{
        setLoading(false);
      }
    // }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "branch", headerName: "Branch", flex: 1 },
    { field: "role", headerName: "Role", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            color="primary"
            onClick={() => navigate(`/employee/edit/${params?.row?.id}`)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => handleDelete(params?.row?.id)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const filteredRows = useMemo(() => {
    return rowData?.filter((row) =>{
      return Object.values(row).some((val) =>{
        return String(val).toLowerCase().includes(searchTerm?.toLowerCase())
      }
      )
    }
    );
  }, [searchTerm, rowData]);

  return (
    <Grid container spacing={3}>      
    {/* Filters Section */}
      <Grid item xs={12} style={{ width:"100%" }}>
        <Paper elevation={3} style={{ padding: 16 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={() => setFiltersOpen(!filtersOpen)}>
              {filtersOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Grid>

          <Collapse in={filtersOpen} timeout="auto" unmountOnExit>
            <Grid container spacing={2} style={{ marginTop: 16 }}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Search"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </Grid>

      {/* Employee Grid Section */}
      <Grid item xs={12} style={{ width:"100%" }}>
        <Paper elevation={3} style={{ padding: 16 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Employee List</Typography>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/employee/register")}
              >
                + Add Employee
              </Button>
            </Grid>
          </Grid>

          <div style={{ height: 400, width: "100%", marginTop: 20 }}>
            {
              loading ? (
                <Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
                <CircularProgress />
                </Grid>
              ): (
                <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10]}
              disableSelectionOnClick
              onRowDoubleClick={(params) =>
                console.log("Double clicked:", params.row)
              }
            />
              )
            }
            
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}
